import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/sync/v1/core/interface/IStore'

export default defineStore('systemSyncStoreV1', {
  state: (): IStore => {
    return {
      queueSize: 0,
      working: false,
    }
  },
})
